<template>
    <div class="user-component">
        <div class="user-body">
            <b-form data-vv-scope="background-form">
                <b-form-group
                    id="image_path"
                >
                    <b-form-file
                        ref="image_path"
                        name="image_path"
                        data-vv-as="File"
                        v-model="foto_profile"
                        :state="Boolean(foto_profile)"
                        type="file"
                        placeholder="Pilih file disini. . ."
                        drop-placeholder="Drop file here..."
                        v-validate="'required'"
                        accept="image/*"
                    >
                    </b-form-file>
                    <span :class="{ 'error-validation': errors.first('foto-profile-form.image_path') }">{{ errors.first('foto-profile-form.image_path') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideFormModal" :disabled="isDisabled">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveData" :disabled="isDisabled">SIMPAN</b-button>
        </div>
    </div>
</template>

<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            id: {
                type: String,
                default: null
            },
            detail: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                isDisabled: false,
                foto_profile : null,
                background_form: {
                    image_path : this.id ? this.detail.image_path: null,
                },
            };
        },
        methods: {
            resetForm() {
                this.background_form.image_path = this.id ? this.detail.image_path : null,
                this.$validator.reset()
            },
            hideFormModal() {
                EventBus.$emit('hideFormModal', true)
                this.resetForm()
            },
            async saveData() {
                let scope = 'background-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.id) {
                            this.background_form.id = this.id
                            this.saveBackground()
                        }
                    }
                });
            },
            async saveBackground() {
                this.isDisabled = true;
                let scope = 'background-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showFotoUploadLoader = true
                        let formData = new FormData()
                        formData.append('image_path', this.foto_profile)
                        formData.append('id', this.id)
                        this.$store.dispatch('saveBackground', formData)
                            .then((res) => {
                                this.$store.dispatch('getBackgroundSettingList')
                                this.hideFormModal()
                                this.showFotoUploadLoader = false
                                this.isDisabled=false
                                this.foto_profile = null
                                this.$validator.reset()
                                this.$swal.fire('Success', res.data.message, 'success')
                            })
                            .catch((err)=> {
                                let error = err.response
                                this.showFotoUploadLoader = false
                                this.isDisabled=false
                                this.hideFormModal()
                                if (error.status == 400) {
                                    this.errorValidate(error.data, scope)
                                } else {
                                this.$swal.fire('Failed', error.data.message, 'error')
                                }
                            })
                    }
                })
			},
        },
		created () {
			EventBus.$on('resetForm', (val) => {
				if (val) {
					this.resetForm()
				}
			})
        }
    }
</script>